import React from 'react'
import { useTranslation } from 'react-i18next'
import "./healthSector.scss"

function HealthSector() {
  const { t } = useTranslation()
  return (
    <div className='container-health-sector'>
      <div>
        <div className="title-health-sector">
          <h1>{t("examples.health_sector.cost_policy.title")} <br /> {t("examples.health_sector.cost_policy.section_text")}</h1>
        </div>
        <div className="div-health-sector">
          <div className="need">
            <h1>{t("examples.health_sector.cost_policy.needs.title")}</h1>
            <div className='texto-need'>
              <ul>
                <li>
                  <p>{t("examples.health_sector.cost_policy.needs.section_text_1")}</p>
                </li>
                <li>
                  <p>{t("examples.health_sector.cost_policy.needs.section_text_2")}</p>
                </li>
                <li>
                  <p>{t("examples.health_sector.cost_policy.needs.section_text_3")}</p>
                </li>
              </ul>
            </div>
          </div>
          <br />
          <div className="solution">
            <h1>{t("examples.health_sector.cost_policy.solutions.title")}</h1>
            <div className='texto-solution'>
              <ul>
                <li>
                  <p>{t("examples.health_sector.cost_policy.solutions.section_text")}</p>
                </li>
              </ul>
            </div>
          </div>
          <br />
          <div className="results">
            <h1>{t("examples.health_sector.cost_policy.results.title")}</h1>
            <div className='texto-results'>
              <ul>
                <li>
                  <p>{t("examples.health_sector.cost_policy.results.section_text_1")}</p>
                </li>
                <li>
                  <p>{t("examples.health_sector.cost_policy.results.section_text_2")}</p>
                </li>
                <li>
                  <p>{t("examples.health_sector.cost_policy.results.section_text_3")}</p>
                </li>
              </ul>
            </div>         
          </div>
        </div>
      </div>
      <div>
        <div className="title-health-sector">
          <h1>{t("examples.health_sector.policy_assurance.title")}<br /> {t("examples.health_sector.policy_assurance.section_text")} </h1>
        </div>
        <div className="div-health-sector">
          <div className="need">
            <h1>{t("examples.health_sector.policy_assurance.needs.title")}</h1>
            <div className='texto-need'>
              <ul>
                <li>
                  <p>{t("examples.health_sector.policy_assurance.needs.section_text_1")}</p>
                </li>
                <li>
                  <p>{t("examples.health_sector.policy_assurance.needs.section_text_2")}</p>
                </li>
                <li>
                  <p>{t("examples.health_sector.policy_assurance.needs.section_text_3")}</p>
                </li>
              </ul>
            </div>
          </div>
          <br />
          <div className="solution">
            <h1>{t("examples.health_sector.policy_assurance.solutions.title")}</h1>
            <div className='texto-solution'>
              <ul>
                <li>
                  <p>{t("examples.health_sector.policy_assurance.solutions.section_text")}</p>
                </li>
              </ul>
            </div>
          </div>
          <br />
          <div className="results">
            <h1>{t("examples.health_sector.policy_assurance.results.title")}</h1>
            <div className='texto-results'>
              <ul>
                <li><p>{t("examples.health_sector.policy_assurance.results.section_text_1")}</p></li>
                <li><p>{t("examples.health_sector.policy_assurance.results.section_text_2")}</p></li>
                <li><p>{t("examples.health_sector.policy_assurance.results.section_text_3")}</p></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default HealthSector